/**
 * Constantes geográficas para Andalucía en UTM30 ETRS89 (EPSG:25830)
 * 
 * Basado en bounding box oficial del IECA con buffer de 5km.
 * Cubre desde Ayamonte (W) hasta Pulpí (E), Tarifa (S) hasta Santa Elena (N).
 * 
 * @module constants/geographic
 */

export const ANDALUCIA_UTM30_BOUNDS = {
  X_MIN: 80000,
  X_MAX: 625000,
  Y_MIN: 3975000,
  Y_MAX: 4295000,
} as const;

/**
 * Verifica si coordenadas UTM30 están dentro de Andalucía
 */
export function isWithinAndalucia(x: number, y: number): boolean {
  return (
    x >= ANDALUCIA_UTM30_BOUNDS.X_MIN &&
    x <= ANDALUCIA_UTM30_BOUNDS.X_MAX &&
    y >= ANDALUCIA_UTM30_BOUNDS.Y_MIN &&
    y <= ANDALUCIA_UTM30_BOUNDS.Y_MAX
  );
}
